package com.example.crashbit

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import kotlinx.browser.document
import kotlinx.browser.window

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    onReady {
        val target = document.getElementById("root") ?: document.body
        if (target != null) {
            val windowAny: dynamic = window
            windowAny.onBrowserPinchZoom = { zoomFactor: Double ->
                val vm: SpaceViewModel? = windowAny.activeViewModel.unsafeCast<SpaceViewModel?>()
                if (vm != null) {
                    val currentScale = vm.scale
                    val newScale = (currentScale * zoomFactor.toFloat()).coerceIn(0.005f, 10f)
                    vm.scale = newScale
                }
            }

            ComposeViewport(viewportContainerId = "root") {
                CrashBitApp(onViewModelCreated = { vm ->
                    windowAny.activeViewModel = vm
                })
            }
            js("if (window.hideAppLoading) { window.hideAppLoading(); }")
        }
    }
}

private fun onReady(block: () -> Unit) {
    var executed = false

    fun executeOnce() {
        if (!executed) {
            executed = true
            block()
        }
    }

    val windowAny: dynamic = window
    if (windowAny.wasmReady == true) {
        executeOnce()
    } else {
        windowAny.onSkikoReady = {
            windowAny.wasmReady = true
            executeOnce()
        }
        val hasOnWasmReady: Boolean = js("typeof onWasmReady === 'function'") as Boolean
        if (hasOnWasmReady) {
            js("onWasmReady(window.onSkikoReady)")
        } else {
            val isDomReady: Boolean = js("document.readyState === 'complete' || document.readyState === 'interactive'") as Boolean
            if (isDomReady) {
                window.setTimeout({ executeOnce() }, 50)
            } else {
                document.addEventListener("DOMContentLoaded", { _ ->
                    window.setTimeout({ executeOnce() }, 50)
                })
            }
        }
    }
}
